import type { Plugin } from 'tippy.js';

/**
 * Plugin Tippy : au focus, l'infobulle ne s'ouvre que pour une navigation au clavier.
 *
 * Le déclencheur `focus` existe pour le clavier (cf. `provideTippyConfig`, main.ts). Mais un
 * panneau ou une modale qui se ferme rend le focus au bouton qui l'avait ouvert : après un
 * clic, l'infobulle de ce bouton s'affichait sans qu'on l'ait survolé. Le navigateur sait
 * distinguer les deux cas : un focus rendu après une interaction à la souris ne correspond
 * pas à `:focus-visible`.
 *
 * Tippy ne permet pas d'annuler l'ouverture depuis un plugin ; on désactive l'instance le
 * temps de l'ouverture planifiée, puis on la réactive.
 */
export const focusClavierSeulement: Plugin = {
  name: 'focusClavierSeulement',
  fn(instance) {
    let minuteur: ReturnType<typeof setTimeout> | undefined;

    return {
      onTrigger(_instance, event) {
        if (event.type !== 'focus' && event.type !== 'focusin') return;
        const reference = instance.reference;
        if (!(reference instanceof HTMLElement) || reference.matches(':focus-visible')) return;

        instance.disable();
        const delai = instance.props.delay;
        const delaiOuverture = (Array.isArray(delai) ? delai[0] : delai) ?? 0;
        clearTimeout(minuteur);
        // Après l'ouverture planifiée (immédiate ou retardée), qu'elle ignore donc.
        minuteur = setTimeout(() => instance.enable(), delaiOuverture + 10);
      },
      onDestroy() {
        clearTimeout(minuteur);
      },
    };
  },
};
